import React, { useEffect, useState } from 'react'
import {user} from "../Join/Join";
import socketIO from "socket.io-client";
import "./Chat.css";
import Message from "../Message/Message";
import ReactScrollToBottom from "react-scroll-to-bottom";

const ENDPOINT = "https://chat-app-jay203.onrender.com/";

let socket;

const Chat = () => {
  const [id, setId] = useState("");
  const [messages, setMessages] = useState([]);


  const send = ()=>{
    const message=document.getElementById("chatInput").value;
    socket.emit('message', {message,id});
    document.getElementById("chatInput").value="";
  }

  
  useEffect(() => {
    socket = socketIO(ENDPOINT, { transports: ['websocket']});
    socket.on("connect", ()=>{
      alert("connected");
      setId(socket.id);
    })

    socket.emit("joined",{ user });

    socket.on("welcome", (data)=>{
      setMessages([...messages, data]);
      console.log(data.user, data.message);
    })

    socket.on("userJoined", (data)=>{
      setMessages([...messages, data]);
      console.log(data.user, data.message);
    })

    socket.on("leave", (data)=>{
      setMessages([...messages, data]);
      console.log(data.user, data.message);
    })

    return () => {
      socket.disconnect();
      socket.off();
    }
  }, []);

  useEffect(()=>{
      socket.on('sendMessage', (data)=>{
        setMessages([...messages, data]);
        console.log(data.user, data.message, data.id);
      })

      return ()=>{
        socket.off();
      }
  },[messages]);

  return (
    <div className='chatPage'>
      <div className="chatContainer">
        <div className='Header'>
          <h2>C CHAT</h2>
          <a href='/'><img src="https://cdn-icons-png.flaticon.com/128/2920/2920658.png" alt="close" /></a>
        </div>
        <ReactScrollToBottom className="chatBox">
          {messages.map((item, i)=> <Message user={item.id===id?"":item.user} message={item.message} classs={item.id===id?"right":'left'} />)}
        </ReactScrollToBottom>
        <div className="inputBox">
          <input onKeyDown={(e)=>e.key==="Enter"?send():null} type="text" id='chatInput' />
          <button onClick={send} id='sendbtn'><img src="https://cdn-icons-png.flaticon.com/128/4024/4024582.png" alt="Send" /></button>
        </div>
      </div>
      
    </div>
  )
}

export default Chat

